var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJokerProLotto4DIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5V21H28.875M36.75 21C36.75 23.0683 36.3426 25.1164 35.5511 27.0273C34.7596 28.9381 33.5995 30.6744 32.1369 32.1369C30.6744 33.5995 28.9381 34.7596 27.0273 35.5511C25.1164 36.3426 23.0683 36.75 21 36.75C18.9317 36.75 16.8836 36.3426 14.9727 35.5511C13.0619 34.7596 11.3256 33.5995 9.86307 32.1369C8.40055 30.6744 7.24041 28.9381 6.4489 27.0273C5.65739 25.1164 5.25 23.0683 5.25 21C5.25 16.8228 6.90937 12.8168 9.86307 9.86307C12.8168 6.90937 16.8228 5.25 21 5.25C25.1772 5.25 29.1832 6.90937 32.1369 9.86307C35.0906 12.8168 36.75 16.8228 36.75 21Z",
    stroke: "url(#paint0_linear_6578_38253)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6578_38253",
    x1: 10.4699,
    y1: 17.7272,
    x2: 42.9855,
    y2: 43.3589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CBB48E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FBE7C9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBB48E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJokerProLotto4DIcon2);
export default __webpack_public_path__ + "static/media/jokerProLotto4dIcon2.1f1eae3e44afe7925ee2dc743532296a.svg";
export { ForwardRef as ReactComponent };